import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { func, string } from 'prop-types';
import { connect } from 'react-redux';
import omitBy from 'lodash/omitBy';
import { useFormState } from 'informed';
import { createQueryParamsFromObject, useIsEqualMemoize } from '../../utils/common';
import Results from '../Results';
import { storeFilters, storeResultCount } from '../../actions';
import { DataContext } from '../../containers/Search/context';

const ResultsContainer = ({ query, store, setResultCount }) => {
  const { values } = useFormState();
  const navigate = useNavigate();
  const api = useContext(DataContext);

  /**
   * Here we overwrite the form query with the context query.
   * The context query is the value from the DebounceInput so it lags
   * behind from the form value.
   */
  const actualValues = {
    ...values,
    query,
  };

  /**
   * In order to prevent the result list from rendering unnecessarily.
   * We make sure the results only re-render when the filters have been changed.
   */
  const [filters, setFilters] = useState(actualValues);

  useEffect(() => {
    setFilters(actualValues);

    // Update URL
    const filteredValues = omitBy(actualValues, (val) => val === '');
    if (filteredValues?.department) {
      const departmentSlug = api.lookupDepartmentSlugById(filteredValues.department);
      if (departmentSlug) {
        filteredValues.department = departmentSlug;
      } else {
        delete filteredValues.department;
      }
    }
    const url = createQueryParamsFromObject(filteredValues);
    navigate(`?${url}`);

    // Save current filters in redux so we can link back on job details page.
    store(filteredValues);
  }, [useIsEqualMemoize(actualValues)]);

  return <Results filters={filters} setResultCount={setResultCount} />;
};

ResultsContainer.propTypes = {
  query: string,
  store: func.isRequired,
  setResultCount: func.isRequired,
};

ResultsContainer.defaultProps = {
  query: '',
};

export default connect(null, (dispatch) => ({
  store: (data) => {
    dispatch(storeFilters(data));
  },
  setResultCount: (count) => {
    dispatch(storeResultCount(count));
  },
}))(ResultsContainer);
